import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <Card className="w-full max-w-md p-8 text-center">
        <h1 className="mb-2 text-2xl font-bold text-text-primary">404</h1>
        <p className="mb-4 text-sm text-text-muted">That page doesn't exist.</p>
        <Button onClick={() => navigate('/')}>Go home</Button>
      </Card>
    </div>
  );
}
